import { Controller } from "@hotwired/stimulus"
import { baseKit } from "../shared/browserKit"
import { dispatchElement } from "../shared/domHelper"
import { debounce } from "../shared/domInputHelper"
import { useClickOutside } from 'stimulus-use'

export default baseKit(({ jsonFetch, html, vRenderNode, dispatchElement })=>{
  return class SearchDatalistController extends Controller {
  
    // usage
    // static targets = [ "item" ]
    // itemTargetConnected(){}
    // itemTargetDisconnected(){}
    // this.itemTarget
    // this.viewTargets
  
    static targets = [
      "input",
      "datalist",
    ]
    
    static values = {
      select: { type: Array, default: [] },
      fetchUrl: { type: String, default: null },
    }

    toggleSelectValue (toggleValue){
      const hasSelectValue = this.selectValue.includes(toggleValue)
      if(hasSelectValue){
        this.selectValue = this.selectValue.filter((value)=>value !== toggleValue)
      } else {
        this.selectValue = [...this.selectValue, toggleValue]
      }
      dispatchElement(this.element, 'search:datalist:select:change', {
        value:  this.selectValue,
      })
      this.renderSearchedOptions()
      this.inputTarget.focus()
    }

    // 검색 리스트
    searchedOptions = []
    renderSearchedOptions (){
      const s = this
      const options = vRenderNode(
        html`<dd 
          v-for="opt in options" 
          :value="opt.value"
          @click="optionClick(opt.value)"
          :selected="checkSelected(opt.value)"
        >{{checkSelected(opt.value) ? '✓ ' : '' }}{{opt.label}}</dd>`, 
        { 
          options: this.searchedOptions,
          optionClick (value){
            s.toggleSelectValue(value)
          },
          checkSelected(value){
            return s.selectValue.includes(value) ? '' : null
          }
        }
      )
      this.datalistTarget.innerHTML = ""
      this.datalistTarget.append(...options)
    }

    resetSelectValue (){
      this.inputTarget.value = ""
      this.searchedOptions = []
      this.datalistTarget.innerHTML = ""
      this.renderSearchedOptions()
    }

    clickOutside(event) {
      if( this.searchedOptions.length ){
        event.preventDefault()
        this.resetSelectValue()
      }
    }

    connect() {
      const rootController = this
      const rootElement = this.element
      useClickOutside(this)
      dispatchElement(this.element, 'search:datalist:select:init', {
        value:  this.selectValue,
      })
    }

    inputTargetConnected (optionElement){
      optionElement.addEventListener("input", (event)=>{
        const value = event.target.value
        console.log(this)
        if(!this.fetchUrlValue){
          throw new Error("SearchDatalistController: data-search-datalist-fetch-url-value is required")
        }
        jsonFetch({
          url: this.fetchUrlValue,
          method: "post",
          body: { search: value },
        }).then((response)=>{
          if(response.ok){
            response.json().then(({ result })=>{
              this.searchedOptions = result
              this.renderSearchedOptions()
            })
          }
        })
      })
      optionElement.addEventListener("keydown", (event)=>{
        if(event.key === "Tab"){
          this.resetSelectValue()
          event.stopPropagation()
        }
        if(event.key === "Escape"){
          this.resetSelectValue()
          event.stopPropagation()
        }
      })
    }
  }
})
